// extracted by mini-css-extract-plugin
module.exports = {"ArrowLink":"styles__ArrowLink___TFzlr","arrow":"styles__arrow___1gr3V"};